<div
  class="search-modal"
  role="dialog"
  aria-modal="true"
  aria-labelledby="user-search-title"
  appFocusTrap
>
  <header class="search-modal__header flex align-center justify-between">
    <div class="flex align-center gap-12">
      <span class="search-modal__header-icon" aria-hidden="true">
        <app-icon
          name="assignment_ind"
          size="sm"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
      </span>
      <div>
        <h2 id="user-search-title" class="search-modal__title fs-16 fw-700 m-0">
          Search by User / Employee
        </h2>
        <p class="fs-12 m-0 search-modal__subtitle">
          Find a staff member or system user and filter the audit log to their actions only.
        </p>
      </div>
    </div>
    <button
      type="button"
      class="search-modal__close"
      (click)="close()"
      aria-label="Close user search"
    >
      <app-icon
        name="close"
        size="sm"
        color="custom"
        customColor="currentColor"
        role="presentation"
      ></app-icon>
    </button>
  </header>

  <div class="search-modal__body">
    <div class="field-grid">
      <div class="field">
        <label class="field__label fs-12 fw-600" for="user-first-name">First Name</label>
        <input
          id="user-first-name"
          class="field__input"
          type="text"
          [value]="firstName()"
          (input)="firstName.set($any($event.target).value)"
          (blur)="firstNameTouched.set(true)"
          (keydown.enter)="search()"
          placeholder="e.g. Jennifer"
          [attr.aria-invalid]="firstNameTouched() && firstNameError() !== null"
          [attr.aria-describedby]="
            firstNameTouched() && firstNameError() ? 'user-first-name-error' : null
          "
        />
        <!--
          Bound conditionally so aria-describedby never points at an element that isn't
          rendered. No role="alert": these fire on blur, and an assertive live region would
          interrupt the screen reader as the user tabs to the next field. The message is
          reached through the input's description instead.
        -->
        @if (firstNameTouched() && firstNameError(); as error) {
        <p id="user-first-name-error" class="field__error fs-12 m-0">{{ error }}</p>
        }
      </div>

      <div class="field">
        <label class="field__label fs-12 fw-600" for="user-last-name">Last Name</label>
        <input
          id="user-last-name"
          class="field__input"
          type="text"
          [value]="lastName()"
          (input)="lastName.set($any($event.target).value)"
          (blur)="lastNameTouched.set(true)"
          (keydown.enter)="search()"
          placeholder="e.g. Martin"
          [attr.aria-invalid]="lastNameTouched() && lastNameError() !== null"
          [attr.aria-describedby]="
            lastNameTouched() && lastNameError() ? 'user-last-name-error' : null
          "
        />
        @if (lastNameTouched() && lastNameError(); as error) {
        <p id="user-last-name-error" class="field__error fs-12 m-0">{{ error }}</p>
        }
      </div>
    </div>

    <div class="search-modal__actions flex justify-end align-center gap-12">
      <button type="button" class="secondary-button fw-600" (click)="clear()">Clear</button>
      <button
        type="button"
        class="primary-button fw-600 flex align-center gap-8"
        (click)="search()"
        [disabled]="!canSearch()"
      >
        <app-icon
          name="search"
          size="xs"
          color="custom"
          customColor="currentColor"
          role="presentation"
        ></app-icon>
        <span>Search</span>
      </button>
    </div>
  </div>
</div>
